/* eslint-disable no-unused-vars */
import { createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import { googleLogout } from "@react-oauth/google";
import CryptoJS from "crypto-js";
import api from "../api";
import { actionsLogin } from "./loginSlice";

function getCookie(name: any) {
  const matches = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  // const justDate = new Date("Thu Dec 08 2022 18:10:50 GMT+0900");
  return matches ? matches[2] : null;
}

function customSetCookie(cname: any, cvalue: any, exdays: any) {
  // d.setMinutes(exdays.getMinutes() + 1);
  // expires = expires.setHours(expires.getHours() + 24);
  const expires = `expires=${exdays}`;
  const temp = `${cname}=${cvalue}; ${expires}`;
  document.cookie = temp;
}

function setLoginCookie(cname: any, cvalue: any, exdays: any) {
  // console.log("setCookie", cname, cvalue, exdays);
  const d = new Date();
  // d.setMinutes(exdays.getMinutes() + 1); // 1분 test용
  // d.setHours(exdays.getHours() + 24); // 1일
  d.setHours(exdays.getHours() + 720); // 14일

  const expiresDays = `expires=${d.toUTCString()}`;
  const temp = `${cname}=${cvalue}; ${expiresDays}; Secure; SameSite=Lax`;
  document.cookie = temp;
}
const axiosDefaultsHeaders = function (token: any) {
  if (token) {
    // localStorage.setItem("Authorization", token);
    setLoginCookie("Authorization", `${token}`, new Date());
    api.defaults.headers.common.Authorization = token;
  } else if (getCookie("Authorization")) {
    api.defaults.headers.common.Authorization =
      getCookie("Authorization") || "";
  }
};
axiosDefaultsHeaders(null);

const kakaoRestApiKey = process.env.REACT_APP_SOCIAL_LOGIN_KAKAO_REST_API_KEY;
const logoutRedirectUri =
  process.env.REACT_APP_SOCIAL_LOGIN_KAKAO_LOGOUT_REDIRECT_URI;

export const thunkLogin = {
  errorReset: createAsyncThunk(
    "errorReset",
    async (reset: any, thunkAPI: any) => {
      // console.log("?loginRead?", user, thunkAPI);

      try {
        thunkAPI.dispatch(actionsLogin.setError(null));
      } catch (error) {
        // console.log("액션에서 에러", error);
        console.log(error);
      }
      // return response.data;
    }
  ),
  loginRead: createAsyncThunk("loginRead", async (user: any, thunkAPI: any) => {
    // console.log("?loginRead?", user, thunkAPI);

    const userPassMD5 = CryptoJS.MD5(user.pw).toString();
    const userPassSHA256 = CryptoJS.SHA256(userPassMD5)
      .toString()
      .toUpperCase();
    try {
      thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: true }));
      const response = await api.post("auth/signin", {
        id: user.id,
        pw: userPassSHA256,
        qcode: user.promotion,
      });
      axiosDefaultsHeaders(`Bearer ${response.data.data.access_token}`);
      localStorage.setItem(
        "Authorization",
        `Bearer ${response.data.data.access_token}`
      );
      localStorage.setItem("lux-last-login", "");
      thunkAPI.dispatch(actionsLogin.setIsLogin(true));
      thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: false }));
    } catch (error) {
      // console.log("액션에서 에러", error);
      thunkAPI.dispatch(actionsLogin.setError(error));
      thunkAPI.dispatch(actionsLogin.setIsLogin(false));
      thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: false }));
    }
    // return response.data;
  }),
  // loginRefresh: createAsyncThunk(
  //   "userRefresh",
  //   async (user: any, thunkAPI: any) => {
  //     // console.log("?userRefresh?", user, thunkAPI);
  //     try {
  //       await api.get(
  //         "notifications/count" // 로그인 상태일때 접근가능한 api(for example)
  //         // "https://api.luxurynall.com/api/v1/main/restorations" // 로그인 상태일때 접근가능한 api(for example)
  //       );
  //       thunkAPI.dispatch(actionsLogin.setIsLogin(true));
  //     } catch (error) {
  //       thunkAPI.dispatch(actionsLogin.setIsLogin(false));
  //     }
  //   }
  // ),
  logout: createAsyncThunk("logout", async (user: any, thunkAPI: any) => {
    // const kakaoAuth = `https://kauth.kakao.com/oauth/logout?client_id=${kakaoRestApiKey}&logout_redirect_uri=${logoutRedirectUri}&response_type=code`;
    // console.log("?logout?", user, thunkAPI);

    // 헤더 토큰 제거
    api.defaults.headers.common.Authorization = "";
    // localStorage.removeItem("Authorization")
    customSetCookie("Authorization", "", -1);

    // 네이버 토큰 제거
    localStorage.removeItem("com.naver.nid.access_token");
    localStorage.removeItem("com.naver.nid.oauth.state_token");

    // 구글 토큰 제거
    googleLogout();

    // 애플은 로그인 정보가 웹에 남지 않음

    // 모든 스토어 비워주고 로그인 상태 false로 변경
    thunkAPI.dispatch(actionsLogin.setIsLogin(false));
    thunkAPI.dispatch(actionsLogin.appleLogin(null));
    thunkAPI.dispatch(actionsLogin.googleLogin(null));
    thunkAPI.dispatch(actionsLogin.naverLogin(null));
    thunkAPI.dispatch(actionsLogin.kakaoLogin(null));
    // window.location.href = "/";

    try {
      const response = await api.get(
        `https://kauth.kakao.com/oauth/logout?client_id=${kakaoRestApiKey}&logout_redirect_uri=${logoutRedirectUri}`
      );
      // console.log("카카오 로그아웃 성공", response);
    } catch (error: any) {
      // console.log("카카오 로그아웃 실패");
    }

    // const { isMyInfo } = useSelector(stateMyInfo);
    // if (isMyInfo.data.member_type === "KAKAO") {
    //   try {
    //     const response = await api.get(
    //       `https://kauth.kakao.com/oauth/logout?client_id=${kakaoRestApiKey}&logout_redirect_uri=${logoutRedirectUri}`
    //     );
    //     // console.log("카카오 로그아웃 성공", response);
    //   } catch (error: any) {
    //     // console.log("카카오 로그아웃 실패");
    //   }
    // }
  }),
  naverLogin: createAsyncThunk(
    "naverLogin",
    async (naver: any, thunkAPI: any) => {
      try {
        thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: true }));
        // // console.log("naver 회원가입", naver);
        const response = await api.post(`auth/signsns`, {
          type: "naver",
          token: naver.naverGetToken,
          qcode: naver.promotion,
        });
        thunkAPI.dispatch(actionsLogin.naverLogin(response.data.data));
        axiosDefaultsHeaders(`Bearer ${response.data.data.access_token}`);
        thunkAPI.dispatch(actionsLogin.setIsLogin(true));
        // localStorage.setItem("lux-last-login", "naver");
        setLoginCookie("lux-last-login", "naver", new Date());
        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
      } catch (error: any) {
        thunkAPI.dispatch(actionsLogin.setIsLogin(false));
        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
        // // console.log(error);
      }
    }
  ),
  googleLogin: createAsyncThunk(
    "googleLogin",
    async (google: any, thunkAPI: any) => {
      try {
        // // console.log("구글 회원가입", google);
        thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: true }));
        const response = await api.post(`auth/signsns`, {
          type: "google",
          token: google.googleGetToken,
          qcode: google.promotion,
        });
        thunkAPI.dispatch(actionsLogin.googleLogin(response.data.data));
        thunkAPI.dispatch(actionsLogin.setIsLogin(true));
        axiosDefaultsHeaders(`Bearer ${response.data.data.access_token}`);
        // localStorage.setItem("lux-last-login", "google");
        setLoginCookie("lux-last-login", "google", new Date());

        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
      } catch (error: any) {
        thunkAPI.dispatch(actionsLogin.setIsLogin(false));
        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
        // // console.log(error);
      }
    }
  ),
  kakaoLogin: createAsyncThunk(
    "kakaoLogin",
    async (kakao: any, thunkAPI: any) => {
      try {
        thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: true }));
        const response = await api.post(`auth/signsns`, {
          type: "kakao",
          token: kakao.kakaoGetToken,
          qcode: kakao.promotion,
        });
        thunkAPI.dispatch(actionsLogin.kakaoLogin(response.data.data));
        axiosDefaultsHeaders(`Bearer ${response.data.data.access_token}`);
        thunkAPI.dispatch(actionsLogin.setIsLogin(true));
        // localStorage.setItem("lux-last-login", "kakao");
        setLoginCookie("lux-last-login", "kakao", new Date());

        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
      } catch (error: any) {
        thunkAPI.dispatch(actionsLogin.setIsLogin(false));
        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
        // // console.log(error);
      }
    }
  ),
  appleLogin: createAsyncThunk(
    "appleLogin",
    async (apple: any, thunkAPI: any) => {
      try {
        // console.log("애플 회원가입 dispatch", apple);
        thunkAPI.dispatch(actionsLogin.handleLoadingSpinner({ loading: true }));
        const response = await api.post(`auth/signsns`, {
          type: "apple",
          token: apple.appleGetToken,
          qcode: apple.qcode,
        });
        thunkAPI.dispatch(actionsLogin.appleLogin(response.data.data));
        axiosDefaultsHeaders(`Bearer ${response.data.data.access_token}`);
        thunkAPI.dispatch(actionsLogin.setIsLogin(true));
        // localStorage.setItem("lux-last-login", "apple");
        setLoginCookie("lux-last-login", "apple", new Date());

        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
      } catch (error: any) {
        thunkAPI.dispatch(actionsLogin.setIsLogin(false));
        thunkAPI.dispatch(
          actionsLogin.handleLoadingSpinner({ loading: false })
        );
        // console.log(error);
      }
    }
  ),
};

export const loginAction = { thunkLogin };
